import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BeforeNavigationHome } from './guards/beforeNavigationHome';

export const router: Routes = [
    {
        path: '',
        loadChildren: 'app/modules/login/login.module#LoginModule',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadChildren: 'app/modules/login/login.module#LoginModule'
    },
    {
        path: 'home',
        loadChildren: 'app/modules/home/home.module#HomeModule',
        canActivate: [BeforeNavigationHome]
    },
    {
        path: 'config',
        loadChildren: 'app/modules/config/config.module#ConfigModule'
    },
    {
        path: 'notif',
        loadChildren: 'app/modules/notif/notif.module#NotifModule'
    },
    {
        path: 'remoteManagement',
        loadChildren: 'app/modules/remotemanagement/remotemanagement.module#RemotemanagementModule'
    },
    {
        path: 'versionControl',
        loadChildren: 'app/modules/versionControl/versioncontrol.module#VersionControlModule'
    },
];

export const appRouter: ModuleWithProviders = RouterModule.forRoot(router);
